import { lighten, makeStyles } from '@material-ui/core/styles';
import theme from "styles/theme"

const useJobsToolbarStyles = makeStyles({
  paperToolbar:{
    padding: 15
  },
  highlight:
    theme.palette.type === 'light'
      ? {
        color: theme.palette.secondary.main,
        backgroundColor: lighten(theme.palette.secondary.light, 0.85),
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
      },
  title: {
    flex: '1 1 auto',
  },
  selection: {
    flex: '1 1 auto',
    textAlign: 'right',
  },
  filters: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  selectFilterMessage: {
    color: 'red',
  }
});

const useJobsToolbarTextFieldStyles = makeStyles({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  dense: {
    marginTop: 19,
  },
  menu: {
    width: 200,
  },
});

const useJobsToolbarDatePickerStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));

const useJobsToolbarSelectStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    width: 200,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const useJobsToolbarButton = makeStyles((theme) => ({
}))


export { useJobsToolbarStyles, useJobsToolbarTextFieldStyles, useJobsToolbarDatePickerStyles, useJobsToolbarSelectStyles, useJobsToolbarButton}
